module.exports = __webpack_public_path__ + "img/case-banner__bg1.png?429b9ca063e81df3a313aa014531c5f0";